import { TreeSelections } from '../data/treeSelection';
import { ModelTreeNode, ParsedTreeNodeType } from '../data/modelOptionsTree';

export class LayoutUtil {
  public static getChildrenType(node : ModelTreeNode) : {
    childrenAreOptions: boolean,
    childrenAreFolders: boolean,
    childrenAreDomains: boolean,
    childrenAreDomainGroups: boolean,
    childrenAreGroups: boolean,
  } {
    return {
      childrenAreOptions: node.children.every((child) => {
        return child.type === ParsedTreeNodeType.Option;
      }),

      childrenAreFolders: node.children.every((child) => {
        return child.type === ParsedTreeNodeType.Folder;
      }),

      childrenAreDomains: node.children.every((child) => {
        return child.type === ParsedTreeNodeType.Domain;
      }),

      childrenAreDomainGroups: node.children.every((child) => {
        return child.type === ParsedTreeNodeType.DomainGroup;
      }),

      childrenAreGroups: node.children.every((child) => {
        return child.type === ParsedTreeNodeType.Group;
      }),
    };
  }

  public static shouldFolderContentBeShown(
    pathParent : string,
    pathNode : string,
    treeSelectionState: TreeSelections,
  ) : boolean {

    const isSelected = treeSelectionState.find(
      (sel) => sel.path === pathParent && sel.value === pathNode,
    ) !== undefined;

    return isSelected;
  }

  public static buildPathForChild(pathNode : string, child : ModelTreeNode) : string {
    if (pathNode.length > 0) {
      return `${pathNode}/${child.name}`;
    }
    return child.name;
  }

  public static shouldShowFoldersAsComboBox(parentNode : ModelTreeNode) : boolean {
    // Attention: Some tests expect the buttons to be there and not the combo box.
    // In the tests, the amount of options rendered each time is 2.
    // So, if we configure here that we want to show a combo box when there's just 2 elements,
    // those tests will fail.
    return parentNode.children.length > 2;
  }
}
